import { render, staticRenderFns } from "./SetClientStatusModal.vue?vue&type=template&id=b2030f6a&scoped=true&"
import script from "./SetClientStatusModal.vue?vue&type=script&lang=js&"
export * from "./SetClientStatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2030f6a",
  null
  
)

export default component.exports